import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l10 10","key":"svg-0"}],["path",{"d":"M17 8l0 9l-9 0","key":"svg-1"}]]

const IconArrowDownRight = createReactComponent('outline', 'arrow-down-right', 'ArrowDownRight', __iconNode);

export default IconArrowDownRight;